export default "__VITE_ASSET__qmZ8_pzr__"